import React from "react";
import { useTheme } from "styled-components";
import QRCode from "react-qr-code";

import {
  ANDROID_APP_LINK,
  BATMAID_GOOGLE_LINK,
  BATMAID_TRUSTPILOT_LINK,
  IOS_APP_LINK,
} from "@config/consts";
import { APP_SELECTOR_ROUTE } from "@config/app.routing";
import { HOMEPAGE_V2 } from "@config/testIds/app";

import {
  TrustPilot,
  Google,
  GooglePlayColored,
  AppStore,
} from "@ui/Assets/Symbolicons";
import { TestWrapper } from "@ui/Atoms";

import { buildUrl } from "@services/BuildUrl";

import { useTranslate } from "@hooks/useTranslate";

import { Group } from "../Group";

import * as Styled from "./AppReviewPayments.styled";
import * as Payments from "./Payments";

export const AppReviewPayments = () => {
  const translate = useTranslate("batmaid_pwa_footer");
  const theme = useTheme();
  const url = buildUrl(
    typeof window !== "undefined"
      ? window.location.origin + APP_SELECTOR_ROUTE
      : "",
  );

  return (
    <Styled.Root>
      <Group title={translate("app_download_header")}>
        <TestWrapper testId={HOMEPAGE_V2.FOOTER_APP_STORES}>
          <Styled.AppLinks>
            <Styled.QRContainer>
              <QRCode
                size={88}
                value={url.done()}
                aria-label={translate("qr_code_area_label")}
              />
            </Styled.QRContainer>
            <Styled.StoreLinks>
              <TestWrapper testId="footer-app-ios">
                <Styled.AppLink
                  href={IOS_APP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AppStore
                    variant="solid"
                    size={120}
                    height={40}
                    background="transparent"
                    color={theme.palette.white}
                  />
                </Styled.AppLink>
              </TestWrapper>

              <TestWrapper testId="footer-app-android">
                <Styled.AppLink
                  href={ANDROID_APP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <GooglePlayColored
                    variant="solid"
                    background="transparent"
                    size={134}
                    height={40}
                    color={theme.palette.white}
                  />
                </Styled.AppLink>
              </TestWrapper>
            </Styled.StoreLinks>
          </Styled.AppLinks>
        </TestWrapper>
      </Group>
      <Group title={translate("review_us_header")}>
        <TestWrapper testId={HOMEPAGE_V2.FOOTER_REVIEW_US}>
          <Styled.Reviews>
            <TestWrapper testId="footer-review-google">
              <a
                href={BATMAID_GOOGLE_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Google
                  variant="solid"
                  size={80}
                  height={27}
                  color={theme.palette.white}
                />
              </a>
            </TestWrapper>

            <TestWrapper testId="footer-review-trustpilot">
              <a
                href={BATMAID_TRUSTPILOT_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <TrustPilot
                  variant="solid"
                  size={115}
                  height={27}
                  color={theme.palette.white}
                />
              </a>
            </TestWrapper>
          </Styled.Reviews>
        </TestWrapper>
      </Group>
      <Group title={translate("payment_methods_header")}>
        <Styled.Payments>
          <Payments.Visa />
          <Payments.Mastercard />
          <Payments.AmericanExpress />
          <Payments.Twint />
        </Styled.Payments>
      </Group>
    </Styled.Root>
  );
};
